import React from 'react'

import DocumentsList from '../../components/Documents/DocumentsList.jsx'
import TenantsSelect from '../../components/Tenants/TenantsSelect.jsx'
import {user} from '../../core/controllers/user';

export default class DocumentsTemplate extends React.Component { 
    constructor(props) {
        super(props);

        this.state = {
            searchString : ''
        };
    }

    search(e) {
        this.setState({
            searchString: e.target.value
        });
    }

    render(){
        return (
            <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title">Documents Center</h4>
                        <p class="category"></p>
                    </div>
                    {/* <div class="content">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="email">Search Documents</label>
                                    <input type="text" value={this.searchString} onChange={this.search.bind(this)} class="form-control tenant-info" name="search" placeholder="Search Documents" id="searcg"/>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div class="content">
                        <DocumentsList sortID='0' search={this.state.searchString}/>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/Documents/Documents.jsx